import { useState } from "react"
import { Form, Input, Select, Button, message } from "antd"
import apiClient from "../../Utils/apiClient"

const { Option } = Select

const CreateRole = ({ onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      const response = await apiClient("/roles", "POST", values)
      if (response.success) {
        message.success("Role created successfully")
        form.resetFields()
        if (onSuccess) onSuccess()
      } else {
        message.error(response.message || "Failed to create role")
      }
    } catch (error) {
      message.error("Error creating role")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        securityGroup: "Network Administrator",
      }}
    >
      <Form.Item
        name="name"
        label="Role Name"
        rules={[{ required: true, message: "Please enter a role name" }]}
      >
        <Input placeholder="Enter role name (e.g., Manager, Employee)" />
      </Form.Item>

      <Form.Item className="text-right mb-0">
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" loading={loading}>
          Create Role
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CreateRole
